import React from 'react';
import '../styles/About.css'; // Import your CSS styles

function About() {
    return (
        <div className="main-content2">
            <div className="container">

            <div className="title-section">
                <h2 className="title-text">About</h2>
                <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/About.png" alt="RFC Problem Analysis" className="title-icon2" />
            </div>
            <br/>
                
                <h4>This is a brief description of the application.</h4>
                
                <div className="image-container">
                    <img className="image" src="https://rfc-info.s3.eu-north-1.amazonaws.com/mapping-tree.png" alt="TREE" />
                </div>

                <h5>Understanding social problems through the problem tree model is vital for effectively addressing them. Here's why:</h5>

                <h3>1. Map the Social Problem</h3>
                <ul>
                    <li><strong>Core Problem (Tree Trunk):</strong> Clearly define the specific issue you want to address. This helps you focus your efforts. For example, Beautiful Minds identified the core problem as "Children in Ethiopia fall sick with diarrhea."</li>
                </ul>
                
                <h3>2. Identify Root Causes and Consequences</h3>
                <ul>
                    <li><strong>Root Causes (Tree Roots):</strong> Determine the underlying factors contributing to the problem. For instance, "low education levels among parents" and "lack of water and soap."</li>
                    <li><strong>Consequences (Tree Branches):</strong> Understand the broader impact if the problem remains unsolved. Examples include "absence from school," "child mortality," and "health care costs."</li>
                </ul>
                
                <h3>3. Find Reliable Data</h3>
                <ul>
                    <li><strong>Validation:</strong> Use credible research to support your problem description. This ensures your efforts are based on solid evidence and helps gain support from funders and partners.</li>
                </ul>

                <h2>Summary</h2>
                <h5>The problem tree model helps you clearly define the problem, identify and address root causes, and articulate the broader impact, ensuring a strategic and credible approach to creating social impact.</h5>
                
            </div>
        </div>
    );
}

export default About;